import React from "react";
import GlobalStyles from "@mui/joy/GlobalStyles";
import IconButton from "@mui/joy/IconButton";
import Sheet from "@mui/joy/Sheet";
import MenuIcon from "@mui/icons-material/Menu";

import { toggleSidebar } from "../../utils/sidebar";

export default function Header() {
  return (
    <Sheet
      sx={{
        display: { xs: "flex", md: "none" },
        position: "fixed",
        top: 0,
        width: "100vw",
        height: "var(--Header-height)",
        alignItems: "center",
        justifyContent: "space-between",
        borderBottom: "1px solid",
        borderColor: "background.level1",
        zIndex: 9995,
        p: 2,
        gap: 1,
        boxShadow: "sm",
        backdropFilter: "blur(12px)",
        backgroundColor: "var(--joy-palette-background-surface)",
      }}
    >
      <GlobalStyles
        styles={(theme) => ({
          ":root": {
            "--Header-height": "52px",
            [theme.breakpoints.up("md")]: {
              "--Header-height": "0px",
            },
          },
        })}
      />
      <IconButton
        size="sm"
        variant="outlined"
        color="neutral"
        onClick={() => toggleSidebar()}
      >
        <MenuIcon />
      </IconButton>
    </Sheet>
  );
}
